// V4's email structure check (something@domain.tld), with "*" not allowed.
// Konnektive treated "*" in a blacklisted email as a wildcard: blacklisting
// "*@gmail.com" blocked every Gmail customer.
//
// Keep this file identical in V3, V4 and V7. V4/src/func/emailValidation.test.js
// checks that the three copies match.
export const EMAIL_REGEX = /^[^@\s*]+@[^@\s*]+\.[^@\s*]{2,}$/;
